import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fe52605"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "photo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "general" }
const _hoisted_6 = { class: "general__name" }
const _hoisted_7 = { class: "general__information" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Rođendan", -1))
const _hoisted_10 = { class: "information" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Visina", -1))
const _hoisted_13 = { class: "information" }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Težina", -1))
const _hoisted_16 = { class: "information" }
const _hoisted_17 = { class: "general__information" }
const _hoisted_18 = { class: "item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Pozicija", -1))
const _hoisted_20 = { class: "information" }
const _hoisted_21 = { class: "item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Dominantna noga", -1))
const _hoisted_23 = { class: "information" }
const _hoisted_24 = { class: "club" }
const _hoisted_25 = { class: "club__name" }
const _hoisted_26 = {
  key: 0,
  class: "club__information"
}
const _hoisted_27 = { class: "item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Trajanje", -1))
const _hoisted_29 = { class: "information" }
const _hoisted_30 = {
  key: 1,
  class: "club__information"
}
const _hoisted_31 = { class: "item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Vrsta", -1))
const _hoisted_33 = { class: "information" }
const _hoisted_34 = { class: "item" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Pozicija", -1))
const _hoisted_36 = { class: "information" }
const _hoisted_37 = { class: "sponsor" }
const _hoisted_38 = { class: "sponsor__name" }
const _hoisted_39 = {
  key: 0,
  class: "sponsor__information"
}
const _hoisted_40 = { class: "item" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Trajanje", -1))
const _hoisted_42 = { class: "information" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CoachPlayersProfileRootUserInformationFormUpdateAvatarIndexVue = _resolveComponent("CoachPlayersProfileRootUserInformationFormUpdateAvatarIndexVue")!
  const _component_CoachPlayersProfileRootUserInformationFormUpdateInformationIndexVue = _resolveComponent("CoachPlayersProfileRootUserInformationFormUpdateInformationIndexVue")!
  const _component_CoachPlayersProfileRootUserInformationFormUpdateContractIndexVue = _resolveComponent("CoachPlayersProfileRootUserInformationFormUpdateContractIndexVue")!
  const _component_CoachPlayersProfileRootUserInformationFormUpdateSponsorIndexVue = _resolveComponent("CoachPlayersProfileRootUserInformationFormUpdateSponsorIndexVue")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-coach-players-profile-root-user-information", {'is-visible': _ctx.isUserInformationVisible}])
  }, [
    _createElementVNode("a", {
      href: "#",
      class: "el-button el-button--primary el-button--small user-information-toggle",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setUserInformationVisibility && _ctx.setUserInformationVisibility(...args)), ["prevent"]))
    }, [
      (_ctx.isUserInformationVisible)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Zatvori"))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, "Informacije"))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: _ctx.getAvatar(_ctx.userInformation.content.avatar),
        alt: ""
      }, null, 8, _hoisted_4),
      _createVNode(_component_CoachPlayersProfileRootUserInformationFormUpdateAvatarIndexVue, {
        userInformation: _ctx.userInformation,
        onGetUserInformation: _ctx.getUserInformation
      }, null, 8, ["userInformation", "onGetUserInformation"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(_toDisplayString(_ctx.userInformation.content.name) + " " + _toDisplayString(_ctx.userInformation.content.surname) + " ", 1),
        _createVNode(_component_CoachPlayersProfileRootUserInformationFormUpdateInformationIndexVue, {
          userInformation: _ctx.userInformation,
          onGetUserInformation: _ctx.getUserInformation
        }, null, 8, ["userInformation", "onGetUserInformation"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.getBirthday(_ctx.userInformation.content.birthday)), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.getHeight(_ctx.userInformation.content.height)), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.getWeight(_ctx.userInformation.content.weight)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.getPosition(_ctx.userInformation.content.position)), 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.getFoot(_ctx.userInformation.content.foot)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createTextVNode(_toDisplayString(_ctx.getContractClub(_ctx.userInformation.content.contract.club)) + " ", 1),
        _createVNode(_component_CoachPlayersProfileRootUserInformationFormUpdateContractIndexVue, {
          userInformation: _ctx.userInformation,
          onGetUserInformation: _ctx.getUserInformation
        }, null, 8, ["userInformation", "onGetUserInformation"])
      ]),
      (_ctx.hasUserSignedContract(_ctx.userInformation.content.contract.club))
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.getBirthday(_ctx.userInformation.content.contract.from)) + " - " + _toDisplayString(_ctx.getBirthday(_ctx.userInformation.content.contract.to)), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasUserSignedContract(_ctx.userInformation.content.contract.club))
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.getType(_ctx.userInformation.content.contract.type)), 1)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.getPosition(_ctx.userInformation.content.contract.position)), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createTextVNode(_toDisplayString(_ctx.getSponsorName(_ctx.userInformation.content.sponsor.name)) + " ", 1),
        _createVNode(_component_CoachPlayersProfileRootUserInformationFormUpdateSponsorIndexVue, {
          userInformation: _ctx.userInformation,
          onGetUserInformation: _ctx.getUserInformation
        }, null, 8, ["userInformation", "onGetUserInformation"])
      ]),
      (_ctx.hasUserSignedSponsor(_ctx.userInformation.content.sponsor.name))
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.getBirthday(_ctx.userInformation.content.contract.from)) + " - " + _toDisplayString(_ctx.getBirthday(_ctx.userInformation.content.contract.to)), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}